import { ComplexAnimatedModal } from "../../../../ui/modal/ComplexAnimatedModal";
import Auth from "../..";
import styles from "./styles.module.scss";

interface IModalRegisterProps {
  opened: boolean;
  isSecondModal?: boolean;
  offsetY: number;
  onClose: (value: false) => void;
}

const AuthModal = ({ opened, onClose, offsetY }: IModalRegisterProps) => {
  return (
    <ComplexAnimatedModal
      opened={opened}
      onClose={() => onClose(false)}
      offsetY={offsetY}
    >
      <div className={styles.authModal}>
        <div className={styles.authModal__container}>
          <Auth onClose={() => onClose(false)} type="signUp" />
        </div>
      </div>
    </ComplexAnimatedModal>
  );
};

export default AuthModal;
